module.exports = __webpack_public_path__ + "img/onboarding-shape-sm.a5f1aff5.svg";